import { createReducer, on } from '@ngrx/store';
import { ImpersonationActions } from '@ps/auth-data-access';

import { INITIAL_REFERENCE_STATE } from '../survey-state.constants';
import { SurveyReferenceApiActions } from './survey-reference.actions';

export const surveyReferenceReducer = createReducer(
  INITIAL_REFERENCE_STATE,

  on(
    SurveyReferenceApiActions.loadTemplatesSuccess,
    (state, { templates, cachedAt }) => ({
      ...state,
      templates,
      templatesCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadTemplatesFailure, (state) => ({
    ...state,
    templates: [],
  })),

  on(
    SurveyReferenceApiActions.loadBuyerManagersSuccess,
    (state, { managers, cachedAt }) => ({
      ...state,
      buyerProjectManagers: managers,
      buyerPmCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadBuyerManagersFailure, (state) => ({
    ...state,
    buyerProjectManagers: [],
  })),

  on(
    SurveyReferenceApiActions.loadOperatorManagersSuccess,
    (state, { managers, cachedAt }) => ({
      ...state,
      operatorProjectManagers: managers,
      operatorPmCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadOperatorManagersFailure, (state) => ({
    ...state,
    operatorProjectManagers: [],
  })),

  on(
    SurveyReferenceApiActions.loadTransactionStatusesSuccess,
    (state, { statuses, cachedAt }) => ({
      ...state,
      transactionStatuses: statuses,
      transactionStatusesCachedAt: cachedAt,
    }),
  ),

  on(SurveyReferenceApiActions.loadTransactionStatusesFailure, (state) => ({
    ...state,
    transactionStatuses: [],
  })),

  on(ImpersonationActions.contextSettled, () => INITIAL_REFERENCE_STATE),
);
